import { type TextProps } from '@pets-ui/Text/Text'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'

export const SoldOutText = (props: TextProps) => {
  const isMobile = useResponsive('mobile')
  return (
    <Text
      variant="caption"
      width={isMobile ? 'auto' : 92.75}
      color={colors.red600}
      align="center"
      {...props}
    />
  )
}
